<template>
  <div>
    <div class="flex md12 mb-4">
      <h5 :style="{ color: this.$themes.primary }">Gestion des retours</h5>
    </div>
    <div class="flex md2 mb-4">
      <va-chip class="fullwidth" :color="statusColor(niveau)">{{
        statusText(niveau)
      }}</va-chip>
    </div>
    <div class="flex md12">
      <va-data-table
        class="va-table--hoverable va-table--stripped"
        :fields="fields"
        :data="filteredData"
        :no-data-label="$t('poissonnierTable.empty')"
        :per-page="10"
        @row-clicked="showElement"
        clickable
      >
        <template slot="nature" slot-scope="props">
          <div class="row row-inside">
            <va-chip
              class="fullwidth"
              :color="props.rowData.hist_type === 'retour' ? 'info' : 'success'"
              >{{ props.rowData.hist_type }}</va-chip
            >
          </div>
        </template>
        <template slot="status" slot-scope="props">
          <div class="row row-inside">
            <va-chip
              v-if="props.rowData.hist_type === 'retour'"
              class="fullwidth"
              :color="statusColor(props.rowData)"
              >{{ statusText(props.rowData) }}</va-chip
            >
          </div>
        </template>
        <template slot="date" slot-scope="props">
          <div class="row row-inside">
            {{
              moment(props.rowData.date_element, "YYYY-MM-DD").format(
                "DD-MM-YYYY"
              )
            }}
          </div>
        </template>
        <template slot="type" slot-scope="props">
          <div class="row row-inside">
            {{
              props.rowData.hist_type === "retour"
                ? textType(props.rowData)
                : "Action"
            }}
          </div>
        </template>
        <template slot="motif" slot-scope="props">
          <div class="row row-inside">
            {{
              props.rowData.hist_type === "retour"
                ? props.rowData.motif_text
                : props.rowData.commentaire
            }}
          </div>
        </template>
        <template slot="commentaire" slot-scope="props">
          <div class="row row-inside">
            {{
              props.rowData.hist_type === "retour"
                ? props.rowData.commentaire
                : ""
            }}
          </div>
        </template>
        <template slot="createur" slot-scope="props">
          <div class="row row-inside">
            {{ props.rowData.prenom + " " + props.rowData.nom }}
          </div>
        </template>
      </va-data-table>
      <div class="row row-inside mt-4">
        <div class="flex md2">
          <va-button class="fullwidth" color="info" @click="openRetour()">
            <va-icon size="15px" name="fa fa-plus" />
            <span>&nbsp Ajouter un retour</span></va-button
          >
        </div>
        <div class="flex md2">
          <va-button class="fullwidth" color="info" @click="openAction()">
            <va-icon size="15px" name="fa fa-plus" />
            <span>&nbsp Ajouter une action</span></va-button
          >
        </div>
      </div>
    </div>

    <manage-retour
      v-model="showRetour"
      :idretour="idSelectedRetour"
      :identreprise="identreprise"
      v-on:update="updateListe"
      v-on:new="updateListe"
    />
    <manage-action
      v-model="showAction"
      :idaction="idSelectedAction"
      :identreprise="identreprise"
      v-on:update="updateListe"
      v-on:new="updateListe"
    />
  </div>
</template>

<script>
import axios from "axios";
import ManageRetour from "../../retours/manageRetour";
import ManageAction from "../../retours/manageAction";
import moment from "moment";

export default {
  name: "tab-retour",
  components: {
    ManageRetour,
    ManageAction,
  },
  props: ["identreprise"],
  data() {
    return {
      niveau: { level: 0, definitif: false },
      perPage: 10,
      idSelectedRetour: null,
      showRetour: false,
      idSelectedAction: null,
      showAction: false,
      isaction: false,
      historique: [],
      moment: moment,
    };
  },
  created() {
    if (this.identreprise) {
      this.updateListe(this.identreprise);
    }
  },
  methods: {
    openRetour() {
      this.idSelectedRetour = null;
      this.showRetour = true;
    },
    openAction() {
      this.idSelectedAction = null;
      this.showAction = true;
    },
    textType(item) {
      if (item.type === "journal") {
        let text = "journal - ";
        if (item.numero) {
          return text + "N°" + item.numero;
        } else {
          return item.date_parution
            ? text +
                "HS " +
                moment(item.date_parution, "YYYY-MM-DD").format("MMMM YYYY")
            : "HS " +
                moment(item.date_previsionnelle, "YYYY-MM-DD").format(
                  "MMMM YYYY"
                );
        }
        return text;
      } else {
        return item.type;
      }
    },
    statusColor(item) {
      //retour definitif, sending is blocked
      if (item.definitif) {
        return "danger";
      }
      if (item.level === 0) {
        return "success";
      }
      if (item.level === 1) {
        return "info";
      }
      if (item.level === 2) {
        return "warning";
      }
      if (item.level >= 3) {
        return "danger";
      }
      return "gray";
    },
    statusText(item) {
      if (item.definitif) {
        return "Retour définitif";
      }
      if (item.level === 0) {
        return "Aucun retour actif";
      }
      if (item.level === 1) {
        return "1er retour";
      }
      if (item.level === 2) {
        return "2eme retour";
      }
      if (item.level === 3) {
        return "3eme retour - bloqué";
      }
      if (item.level >= 3) {
        return item.level + " retours - bloqué";
      }
      return "gray";
    },
    showElement(element) {
      if (element.hist_type === "action") {
        this.idSelectedAction = element.idaction_retour_entreprise;
        this.showAction = true;
      } else if (element.hist_type === "retour") {
        this.idSelectedRetour = element.idretour_entreprise;
        this.showRetour = true;
      }
    },
    async updateListe() {
      let tmp = await this.getHistorique(this.identreprise);
      this.historique = tmp.historique;
      this.niveau = { level: tmp.level, definitif: tmp.definitif };
    },
    async getHistorique(identreprise) {
      try {
        let res = await axios.get("api/retours/historique", {
          params: { identreprise: identreprise },
        });
        return res.data;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
        return -1;
      }
    },
  },
  watch: {
    identreprise() {
      if (this.identreprise) {
        this.updateListe();
      }
    },
  },
  computed: {
    filteredData() {
      return this.historique;
    },
    fields() {
      return [
        {
          name: "__slot:nature",
          title: "Nature",
          sortField: "hist_type",
          width: "10%",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "level",
          width: "10%",
        },
        {
          name: "__slot:date",
          title: "Date",
          sortField: "date_element",
          width: "5%",
        },
        {
          name: "__slot:type",
          title: "Type",
          width: "5%",
        },

        {
          name: "__slot:motif",
          title: "Motif / Action",
          width: "10%",
        },
        {
          name: "__slot:commentaire",
          title: "Commentaire retour",
          width: "10%",
        },
        {
          name: "__slot:createur",
          title: "Créateur",
          width: "10%",
        },
      ];
    },
  },
};
</script>

<style>
</style>
